import UI from './modules/ui';

export default {
    UI
};
